import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = ["disabled", "title", "name"];
var _hoisted_2 = ["src", "alt"];
var _hoisted_3 = {
    key: 2,
    class: "block"
};
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Button',
    props: {
        buttonClass: { type: String, required: false },
        text: { type: String, required: false },
        name: { type: String, required: false },
        disabled: { type: Boolean, required: false, default: false },
        icon: { type: String, required: false },
        imgIcon: { type: String, required: false },
        iconClass: { type: String, required: false },
        buttonStyle: { type: Object, required: false },
        iconStyle: { type: Object, required: false },
    },
    emits: [
        'onDoAction',
    ],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var onDoAction = function (e) {
            e.preventDefault();
            emit('onDoAction');
        };
        /** ボタンに適用するスタイルをオブジェクト形式で取得します */
        var componentStyle = computed(function () {
            if (!props.buttonStyle) {
                return {
                    'background-color': 'transparent',
                    color: '#000',
                    'font-size': 'medium',
                    'font-weight': 'normal',
                    border: '1px solid #1565C0',
                    'border-radius': '2px',
                    width: 'auto',
                    height: 'auto',
                };
            }
            else {
                return {
                    'background-color': props.buttonStyle.backgroundColor,
                    color: props.buttonStyle.color,
                    'font-size': props.buttonStyle.fontSize,
                    'font-weight': props.buttonStyle.fontWeight,
                    border: props.buttonStyle.border,
                    width: props.buttonStyle.width,
                    height: props.buttonStyle.height,
                };
            }
        });
        /** アイコンに適用するスタイルをオブジェクト形式で取得します */
        var iconStyleObj = computed(function () {
            if (!props.iconStyle) {
                return {
                    width: 'auto',
                    height: 'auto',
                };
            }
            else {
                return {
                    width: props.iconStyle.width,
                    height: props.iconStyle.height,
                };
            }
        });
        /** ボタンに適用するスタイルをtailwindクラスとして取得します */
        var componentClass = computed(function () {
            return props.buttonClass;
        });
        /** アイコン自体とアイコンに適用するスタイルをtailwindクラスとして取得します */
        var iconComponentClass = computed(function () {
            if (props.icon && !props.iconClass) {
                return props.icon;
            }
            else if (props.icon) {
                // class="アイコン名 tailwindClass"の形にしてreturnしている
                return props.icon + ' ' + props.iconClass;
            }
            else if (props.imgIcon && !props.iconClass) {
                return;
            }
            return props.iconClass;
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("button", {
                class: _normalizeClass(["rounded", componentClass.value]),
                style: _normalizeStyle(componentStyle.value),
                disabled: __props.disabled,
                title: __props.text,
                name: __props.name,
                onClick: onDoAction
            }, [
                _renderSlot(_ctx.$slots, "default"),
                (__props.icon)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass(iconComponentClass.value),
                        style: _normalizeStyle(iconStyleObj.value)
                    }, null, 6))
                    : (__props.imgIcon)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: "/assets/img/".concat(__props.imgIcon),
                            alt: __props.name,
                            class: _normalizeClass(iconComponentClass.value),
                            style: _normalizeStyle(iconStyleObj.value)
                        }, null, 14, _hoisted_2))
                        : _createCommentVNode("", true),
                (__props.text)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.text), 1))
                    : _createCommentVNode("", true)
            ], 14, _hoisted_1));
        };
    }
});
